// extracted by mini-css-extract-plugin
export default {"Lato":"Lato, Helvetica, Arial, sans-serif","eigengrau":"#101828","heading":"styles_heading__f2Na6"};